import gql from 'graphql-tag';
import { PromotionBasicFields } from './fragments/Promotion';

const key = `DeletePromotion`;

const mutation = gql`
${PromotionBasicFields}
mutation ${key}($input:DeletePromotionInput!) {
  deletePromotion(input: $input) {
    ...PromotionBasicFields
  }
}
`;

export const DELETE_PROMOTION = { key, mutation };
